import { TFunction } from 'i18next';

import { LENGTH_XS, LENGTH_M } from '../constants';

export const deskRules = (t: TFunction) => ({
  name: { required: true, maxLength: LENGTH_XS },
  description: { required: true, maxLength: LENGTH_M },
  keepAlive: {
    required: { value: true, message: 'This is a required field' },
    validate: {
      maxValue: (v) =>
        parseInt(v, 10) <= 900 || t('errors.value_boundaries', { 0: 'Max', 1: '900' }),
      minValue: (v) => parseInt(v, 10) >= 1 || t('errors.value_boundaries', { 0: 'Min', 1: '1' }),
    },
  },
});
